import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_e7ffdd35bd: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_e7ffdd35bd",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "Under $35 Small Thematic Trinkets",
  description:
    "A selection of hand-painted clips, jewelry, and mini accessories designed to fit subscription box constraints while staying under a $35 total cost.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/a6e6e60a95e4bf4a0b12b7a88ce36b5f390e70e52036f6a976c3555c930e8d1d.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/a6e6e60a95e4bf4a0b12b7a88ce36b5f390e70e52036f6a976c3555c930e8d1d.jpeg",
    "https://cdn.faire.com/fastly/aee55584f94a22f4870efdc760128be30bcd83b2925ea523efc31551b6b9e836.jpeg",
    "https://cdn.faire.com/fastly/1e238b3331a5b02f1cb543b76d797ee834acbe60a525442d74d8d7108703b6da.jpeg",
    "https://cdn.faire.com/fastly/9b28ed18f75fade8290faabf908d6472bbb1bfe3a4afb72f0e13aa94bbd92cc1.jpeg",
    "https://cdn.faire.com/fastly/debbe422a5ad633a090b875d3c8d74f0889cc4d6a85eddb6bca41a0a360b1431.jpeg",
    "https://cdn.faire.com/fastly/5481f50713e62c934e2b0d0714cd1ffdb884b81d2e80ab1a2e75b22bebfaa915.jpeg",
  ],
  itemCount: 55,
  source: "eric_themes_ideas",
  teaser: "thi_e7ffdd35bd",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
